module.exports = __webpack_public_path__ + "img/camera-mic.2086096e.svg";